// Helpers locales simples
const getSafeInt = (val) => {
    if (val === 0 || val === "0") return 0;
    if (val === undefined || val === null || val === "") return 0;
    const cleanVal = String(val).replace(/\D/g, ''); 
    return cleanVal.length > 0 ? parseInt(cleanVal, 10) : 0;
};

/**
 * getValue - Busca el valor en la fila probando varios nombres de columna posibles.
 */
const getValue = (row, possibleNames) => {
    const names = Array.isArray(possibleNames) ? possibleNames : [possibleNames];
    const rowKeys = Object.keys(row);
    
    for (const name of names) {
        const normalizedToFind = name.toLowerCase().trim();
        const foundKey = rowKeys.find(k => k.toLowerCase().trim() === normalizedToFind);
        if (foundKey !== undefined) return row[foundKey];
    }
    return undefined;
};

export const LaSegundaStrategy = {
    name: "LA SEGUNDA",
    
    /**
     * cleanSearchValue: Estandariza el nPoliza como String y quita el .0 de Excel.
     */
    cleanSearchValue: (rawVal) => {
        if (rawVal === 0 || rawVal === "0") return "0";
        if (rawVal === undefined || rawVal === null || rawVal === "") return '';
        
        let s = String(rawVal).trim();
        if (s.endsWith('.0')) s = s.replace('.0', '');
        return s;
    },

    /**
     * findExistingRecord: BUSQUEDA PROFESIONAL EN MEMORIA.
     * Para La Segunda, el match de unicidad en la cobranza se hace por el campo 'cuota'.
     */
    findExistingRecord: (row, existingRecords) => {
        if (!existingRecords || existingRecords.length === 0) return null;

        const cuotaExcel = getSafeInt(getValue(row, ['Cuota', 'nCuota', 'Cuota Nro']));

        // Buscamos en el listado de la DB que nos pasó el orquestador
        return existingRecords.find(rec => 
            getSafeInt(rec.cuota) === cuotaExcel
        ) || null;
    },

    processRow: (row, existingRecord) => {
        // 1. Extracción y Limpieza de Importe ACTUAL
        let importeActual = 0;
        const rawImporte = getValue(row, ['Importe', 'Monto', 'Valor', 'Total']);

        if (rawImporte !== undefined && rawImporte !== null && rawImporte !== '') {
            if (typeof rawImporte === 'number') {
                importeActual = rawImporte;
            } else {
                const stringValue = String(rawImporte);
                const cleanValue = stringValue
                    .replace(/\$/g, '')
                    .replace(/\s/g, '')
                    .replace(/\./g, '')
                    .replace(',', '.');
                
                importeActual = parseFloat(cleanValue);
                if (isNaN(importeActual)) importeActual = 0;
            }
        }
        
        const moneda = getValue(row, ['Moneda', 'Divisa']) || '$';
        const formaPagoExcel = getValue(row, ['FormaPago', 'Forma de Pago', 'Medio']) || 'Tarjeta de Credito';
        const motivoExcel = getValue(row, ['Motivo', 'Desc. Motivo']) || '';
        const nPolizaRaw = getValue(row, ['nPoliza', 'Póliza', 'Poliza']);
        const nPoliza = LaSegundaStrategy.cleanSearchValue(nPolizaRaw);
        const cleanCuota = getSafeInt(getValue(row, ['Cuota', 'nCuota']));

        // 2. Definición del Intento de Cobro (Idempotencia)
        const excelIntento = getSafeInt(getValue(row, ['IntentoCobro', 'Intento']));
        const intentoFinal = excelIntento > 0 
            ? excelIntento 
            : (existingRecord ? (getSafeInt(existingRecord.intentoCobro) + 1) : 1);

        // 3. Variables de estado a determinar
        let estadoGestion = '';
        let estadoDeuda = '';
        let motivoDeuda = motivoExcel;

        if (existingRecord && getSafeInt(existingRecord.intentoCobro) === intentoFinal) {
            estadoGestion = existingRecord.estado || 'Pendiente';
            estadoDeuda = existingRecord.estadoDeuda || 'Rechazo';
            if (!motivoDeuda) motivoDeuda = existingRecord.motivoDeuda;
        } else {
            // Lógica específica para La Segunda según medio de pago
            const formaPagoUpper = String(formaPagoExcel).toUpperCase();
            if (formaPagoUpper.includes('CBU')) {
                if (intentoFinal === 1) {
                    estadoGestion = 'Sin Asignar';
                    estadoDeuda = 'Intento de Cobro';
                } else {
                    estadoGestion = 'Pendiente';
                    estadoDeuda = 'Rechazo';
                }
            } else {
                // Tarjetas de Crédito u Otros
                estadoGestion = intentoFinal === 1 ? 'Sin Asignar' : 'Pendiente';
                estadoDeuda = 'Rechazo';
            }
        }

        return {
            action: 'SAVE',
            data: {
                cuota: cleanCuota,
                nPoliza: String(nPoliza), 
                intentoCobro: intentoFinal,
                motivoDeuda: motivoDeuda,
                importe: importeActual,
                moneda: moneda,
                estadoDeuda: estadoDeuda,
                estado: estadoGestion,
                formaPago: formaPagoExcel,
                ultimaImportacion: new Date().toISOString(),
            }
        };
    }
};